import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import * as CryptoJS from 'crypto-js';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon'; 

@Component({
  selector: 'app-sidenav-solicitacao',
  templateUrl: './sidenav-solicitacao.component.html',
  styleUrls: ['./sidenav-solicitacao.component.scss']
})
export class SidenavSolicitacaoComponent implements OnInit {

  public arrayString: string;
  public superUser = false;
  public createEmpresa = false;
  public editEmpresa = false;
  public deleteEmpresa = false;
  public viewEmpresa = false;
  public semPermisao = true;

  constructor(
    public dialog: MatDialog,
    public router: Router,
    private solicitacaoService: SolicitacaoService,
    private sanitizer: DomSanitizer,
    iconRegistry: MatIconRegistry) {
      iconRegistry.addSvgIcon('gerenciarProtocolo', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/novo_protocolo.svg'));
     }

  ngOnInit() {
    this.getAuthority();
  }

  getAuthority() {
    this.getItemAuthority('authority');
      if (this.arrayString.includes('LIST_SOLICITACAO')) {
        this.viewEmpresa = true;
        this.semPermisao = false;
      }
      if (this.arrayString.includes('DELETE_SOLICITACAO')) {
        this.deleteEmpresa = true;
        this.semPermisao = false;
      }
      if (this.arrayString.includes('EDIT_SOLICITACAO')) {
        this.editEmpresa = true;
        this.semPermisao = false;
      }
      if (this.arrayString.includes('ADD_SOLICITACAO')) {
        this.createEmpresa = true;
        this.semPermisao = false;
      }
      if (this.arrayString.includes('SUPER_USER')) {
        this.superUser = true;
        this.semPermisao = false;
      }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
        try {
            const bytes = CryptoJS.AES.decrypt(store, sessionStorage.getItem('ticket-ECM'));
            this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return this.arrayString;
        } catch (e) {
            sessionStorage.clear();
        }
    }

    return null;
  }

  goToAddSolic() {
    const data = null;  // Dados que você quer enviar
    this.solicitacaoService.changeData(data);
    this.router.navigate(["/adicionar-solicitacao"]);
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/sidenav-solicitacao/sidenav-solicitacao.component.ts